// extracted by mini-css-extract-plugin
module.exports = {"non-endemic-banner-container":"non-endemic-banner-container--742wn","non-endemic-banner":"non-endemic-banner--742wn"};